/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Default_FilenameInputs */

const en_dialog_text_to_audio_default_filename = /** @type {(inputs: Dialog_Text_To_Audio_Default_FilenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Audio`)
};

const es_dialog_text_to_audio_default_filename = /** @type {(inputs: Dialog_Text_To_Audio_Default_FilenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a audio`)
};

/**
* | output |
* | --- |
* | "Text to Audio" |
*
* @param {Dialog_Text_To_Audio_Default_FilenameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_default_filename = /** @type {((inputs?: Dialog_Text_To_Audio_Default_FilenameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Default_FilenameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_default_filename(inputs)
	return en_dialog_text_to_audio_default_filename(inputs)
});